// extracted by mini-css-extract-plugin
export default {"actionCard":"LMFG7uaAgms7Y5g2eb1t","actionHeading":"NERqs7AULoP8FOjNV1gc","actionMessage":"zqGnA8jQcO0CtPFp5Zna","actionList":"D7qa18rzZQCciH0K1g_Z"};